import { useState } from 'react';
import styles from './PasswordChangeModal.module.css';

const ERROR_MSG = {
  invalid_credentials: '현재 비밀번호가 올바르지 않습니다.',
  password_too_short: '새 비밀번호는 최소 8자 이상이어야 합니다.',
  missing_fields: '모든 필드를 입력해주세요.',
};

export default function PasswordChangeModal({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    if (next !== confirm) return setError('새 비밀번호가 일치하지 않습니다.');
    if (next.length < 8) return setError(ERROR_MSG.password_too_short);
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/password-change', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(ERROR_MSG[data.error] || '변경에 실패했습니다.');
        return;
      }
      setSuccess(true);
      setTimeout(onClose, 1500);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h2 className={styles.title}>비밀번호 변경</h2>
        <form onSubmit={onSubmit}>
          <div className={styles.field}>
            <label className={styles.label}>현재 비밀번호</label>
            <input className={styles.input} type="password" required
              value={current} onChange={e => setCurrent(e.target.value)} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>새 비밀번호 (8자 이상)</label>
            <input className={styles.input} type="password" required minLength={8}
              value={next} onChange={e => setNext(e.target.value)} />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>새 비밀번호 확인</label>
            <input className={styles.input} type="password" required minLength={8}
              value={confirm} onChange={e => setConfirm(e.target.value)} />
          </div>
          {error && <p className={styles.error}>{error}</p>}
          {success && <p className={styles.success}>변경되었습니다.</p>}
          <div className={styles.actions}>
            <button type="button" className={styles.cancel} onClick={onClose}>취소</button>
            <button type="submit" className={styles.submit} disabled={submitting || success}>
              {submitting ? '변경 중...' : '변경'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
